<template>
  <div class="c-view">
    <div class="c-view__two" v-bind:class="{ active: view === 2 }" @click="setView(2)"></div>
    <div class="c-view__four" v-bind:class="{ active: view === 4 }" @click="setView(4)"></div>
  </div>
</template>

<script>
export default {
  name: "CatalogView",
  props: {
    view: Number,
    view_name: String
  },
  methods: {
    setView(view) {
      fetch('/api/catalog/settings/view/', {
        method: 'POST',
        body: JSON.stringify({'count': view, 'view_name': this.view_name})
      })
          .then(response => response.json())
          .then(result => {
            if (!result.success)
              window.toast.error(result.message);
            else
              location.reload();
          })
    },
  }
}
</script>

<style scoped>

</style>